<template>
    <ubi-page-container>

        <!--DEBUT : SFC-->
        <ubi-panel>
            <h1>{{ $t("layouts.localReference") }}</h1>
            <div style="margin-left: 5%; margin-right: 5%; font-size: 130%;">
                <p class="text-justify">{{ $t("presenceLocale.text1") }}<span class="text-highlight">{{ $t("presenceLocale.keywordText1")}}</span></p>
                <p class="text-justify">
                    <strong>{{ $t("presenceLocale.text2Bold") }}</strong>
                    <br /><br />
                    {{ $t("presenceLocale.text2") }}
                </p>
                <p class="text-justify">
                    <strong>{{ $t("presenceLocale.text3Bold") }}</strong>
                    <br /><br />
                    {{ $t("presenceLocale.text3") }} <span class="text-highlight">{{ $t("presenceLocale.keywordText3")}}</span> {{ $t("presenceLocale.suiteText3") }}
                </p>
                <p class="text-justify">
                    <strong>{{ $t("presenceLocale.text4Bold") }}</strong>
                    <br /><br />
                    {{ $t("presenceLocale.text4") }}
                </p>
                <p class="text-justify">
                    <strong>{{ $t("presenceLocale.text5Bold") }}</strong>
                    <br /><br />
                    {{ $t("presenceLocale.text5") }}
                </p>
                <p class="text-justify">
                    {{ $t("presenceLocale.text6") }}<br/>
                    {{ $t("presenceLocale.text7") }}<span class="text-highlight">{{ $t("presenceLocale.cashPhrase")}}</span>
                </p>
            </div>
            <br><br>
            <div class="text-center">
                <el-row>
                    <el-button v-if="!isSubUser" @click="send">{{ $t("presenceLocale.beContacted") }}</el-button>
                </el-row>
                <br/>
                <el-row>
                    <el-button type="primary">
                        <a :href="urlAutologin" id="lienBouton2" target="_blank" rel="noopener" @click="eventAnalytics('me_connecter')" >
                            {{ $t("presenceLocale.alreadyClient") }}
                        </a>
                    </el-button>
                </el-row>
            </div>
        </ubi-panel>
        <!--FIN : SFC-->
    </ubi-page-container>
</template>

<script>
import { sendEmail } from '@/services/email'
import { mapGetters } from 'vuex'
import { getUrlAutologin } from '@/services/digitalBricks'
import UbiPageContainer from '@/components/PageContainer.vue'
import UbiPanel from '@/components/Panel.vue'

export default {
  name: 'Presence',
  components: { UbiPanel, UbiPageContainer },
  data () {
    return {
      sendTo: null,
      urlAutologin: null
    }
  },
  computed: {
    ...mapGetters(['isSubUser']),
    ...mapGetters('productLine', ['hasLocalSeo']),
    user () {
      return this.$store.getters.getUser
    },
    sitimmoUser () {
      return this.$store.getters.getSitimmoUser
    }
  },
  beforeMount () {
    this.getUrlAutologinDb()
  },
  methods: {
    eventAnalytics (category) {
      this.$ga.event('sfc', 'clic', category, this.sitimmoUser.id)
    },
    async send () {
      this.$ga.event('sfc', 'clic', 'etre_recontacte', this.sitimmoUser.id)
      this.loading = true
      this.sendTo = processEnvConfig.VUE_APP_ADRESSE_MAIL_CONTACT_MARKETING
      const mailData = {
        to: this.sendTo,
        subject: this.$t('presenceLocale.emailSubject', { advertiser: this.user.advertiser }),
        email_content: this.$t('presenceLocale.emailContent', { advertiser: this.user.advertiser, companyName: this.sitimmoUser.nom, email: this.sitimmoUser.email, phoneNumber: this.sitimmoUser.telephone })
      }
      const response = await sendEmail(mailData)
      if (response.type === 'error') {
        this.$message({ message: this.$t('error.found'), type: 'error' })
        this.loading = false
        return false
      }
      window.alert(this.$t('presenceLocale.dialogMessage'))
      this.loading = false
    },
    async getUrlAutologinDb () {
      const dataAutoLogin = await (getUrlAutologin())
      this.urlAutologin = dataAutoLogin.url
    }
  }
}
</script>

<style>
    #lienBouton1{
        color: grey;
        text-decoration: none;
    }
    #lienBouton2{
        color: white;
        text-decoration: none;
    }
    .text-highlight {
        color: #0ab1bf;
        font-weight: 700;
    }
</style>
